var cov_1epw84o1x7 = function () {
  var path = "/Users/spana/SHEIN/shineout/src/utils/notification.ts",
      hash = "6a850041973480fa23d65e4aae7b24765b0a34ff",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/utils/notification.ts",
    statementMap: {
      "0": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 13,
          column: 21
        }
      },
      "1": {
        start: {
          line: 17,
          column: 18
        },
        end: {
          line: 17,
          column: 36
        }
      },
      "2": {
        start: {
          line: 18,
          column: 4
        },
        end: {
          line: 18,
          column: 22
        }
      },
      "3": {
        start: {
          line: 18,
          column: 16
        },
        end: {
          line: 18,
          column: 22
        }
      },
      "4": {
        start: {
          line: 19,
          column: 4
        },
        end: {
          line: 19,
          column: 48
        }
      },
      "5": {
        start: {
          line: 19,
          column: 36
        },
        end: {
          line: 19,
          column: 47
        }
      },
      "6": {
        start: {
          line: 23,
          column: 4
        },
        end: {
          line: 23,
          column: 52
        }
      },
      "7": {
        start: {
          line: 23,
          column: 29
        },
        end: {
          line: 23,
          column: 52
        }
      },
      "8": {
        start: {
          line: 24,
          column: 19
        },
        end: {
          line: 24,
          column: 37
        }
      },
      "9": {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 25,
          column: 35
        }
      },
      "10": {
        start: {
          line: 25,
          column: 29
        },
        end: {
          line: 25,
          column: 35
        }
      },
      "11": {
        start: {
          line: 26,
          column: 4
        },
        end: {
          line: 26,
          column: 19
        }
      },
      "12": {
        start: {
          line: 30,
          column: 4
        },
        end: {
          line: 30,
          column: 35
        }
      },
      "13": {
        start: {
          line: 30,
          column: 29
        },
        end: {
          line: 30,
          column: 35
        }
      },
      "14": {
        start: {
          line: 32,
          column: 4
        },
        end: {
          line: 33,
          column: 34
        }
      },
      "15": {
        start: {
          line: 32,
          column: 12
        },
        end: {
          line: 32,
          column: 73
        }
      },
      "16": {
        start: {
          line: 32,
          column: 64
        },
        end: {
          line: 32,
          column: 72
        }
      },
      "17": {
        start: {
          line: 33,
          column: 9
        },
        end: {
          line: 33,
          column: 34
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 12,
            column: 2
          },
          end: {
            line: 12,
            column: 3
          }
        },
        loc: {
          start: {
            line: 12,
            column: 16
          },
          end: {
            line: 14,
            column: 3
          }
        },
        line: 12
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 16,
            column: 2
          },
          end: {
            line: 16,
            column: 3
          }
        },
        loc: {
          start: {
            line: 16,
            column: 47
          },
          end: {
            line: 20,
            column: 3
          }
        },
        line: 16
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 19,
            column: 18
          },
          end: {
            line: 19,
            column: 19
          }
        },
        loc: {
          start: {
            line: 19,
            column: 36
          },
          end: {
            line: 19,
            column: 47
          }
        },
        line: 19
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 22,
            column: 2
          },
          end: {
            line: 22,
            column: 3
          }
        },
        loc: {
          start: {
            line: 22,
            column: 46
          },
          end: {
            line: 27,
            column: 3
          }
        },
        line: 22
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 29,
            column: 2
          },
          end: {
            line: 29,
            column: 3
          }
        },
        loc: {
          start: {
            line: 29,
            column: 48
          },
          end: {
            line: 34,
            column: 3
          }
        },
        line: 29
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 32,
            column: 59
          },
          end: {
            line: 32,
            column: 60
          }
        },
        loc: {
          start: {
            line: 32,
            column: 64
          },
          end: {
            line: 32,
            column: 72
          }
        },
        line: 32
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 18,
            column: 4
          },
          end: {
            line: 18,
            column: 22
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 18,
            column: 4
          },
          end: {
            line: 18,
            column: 22
          }
        }, {
          start: {
            line: 18,
            column: 4
          },
          end: {
            line: 18,
            column: 22
          }
        }],
        line: 18
      },
      "1": {
        loc: {
          start: {
            line: 23,
            column: 4
          },
          end: {
            line: 23,
            column: 52
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 23,
            column: 4
          },
          end: {
            line: 23,
            column: 52
          }
        }, {
          start: {
            line: 23,
            column: 4
          },
          end: {
            line: 23,
            column: 52
          }
        }],
        line: 23
      },
      "2": {
        loc: {
          start: {
            line: 25,
            column: 4
          },
          end: {
            line: 25,
            column: 35
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 25,
            column: 4
          },
          end: {
            line: 25,
            column: 35
          }
        }, {
          start: {
            line: 25,
            column: 4
          },
          end: {
            line: 25,
            column: 35
          }
        }],
        line: 25
      },
      "3": {
        loc: {
          start: {
            line: 30,
            column: 4
          },
          end: {
            line: 30,
            column: 35
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 30,
            column: 4
          },
          end: {
            line: 30,
            column: 35
          }
        }, {
          start: {
            line: 30,
            column: 4
          },
          end: {
            line: 30,
            column: 35
          }
        }],
        line: 30
      },
      "4": {
        loc: {
          start: {
            line: 32,
            column: 4
          },
          end: {
            line: 33,
            column: 34
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 32,
            column: 4
          },
          end: {
            line: 33,
            column: 34
          }
        }, {
          start: {
            line: 32,
            column: 4
          },
          end: {
            line: 33,
            column: 34
          }
        }],
        line: 32
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

var Notification =
/*#__PURE__*/
function () {
  function Notification() {
    _classCallCheck(this, Notification);

    this.$events = void 0;
    cov_1epw84o1x7.f[0]++;
    cov_1epw84o1x7.s[0]++;
    this.$events = {};
  }

  _createClass(Notification, [{
    key: "dispatch",
    value: function dispatch(name) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      cov_1epw84o1x7.f[1]++;
      var event = (cov_1epw84o1x7.s[1]++, this.$events[name]);
      cov_1epw84o1x7.s[2]++;

      if (!event) {
        cov_1epw84o1x7.b[0][0]++;
        cov_1epw84o1x7.s[3]++;
        return;
      } else {
        cov_1epw84o1x7.b[0][1]++;
      }

      cov_1epw84o1x7.s[4]++;
      event.forEach(function (fn) {
        cov_1epw84o1x7.f[2]++;
        cov_1epw84o1x7.s[5]++;
        return fn.apply(void 0, args);
      });
    }
  }, {
    key: "subscribe",
    value: function subscribe(name, fn) {
      cov_1epw84o1x7.f[3]++;
      cov_1epw84o1x7.s[6]++;

      if (!this.$events[name]) {
        cov_1epw84o1x7.b[1][0]++;
        cov_1epw84o1x7.s[7]++;
        this.$events[name] = [];
      } else {
        cov_1epw84o1x7.b[1][1]++;
      }

      var events = (cov_1epw84o1x7.s[8]++, this.$events[name]);
      cov_1epw84o1x7.s[9]++;

      if (events.includes(fn)) {
        cov_1epw84o1x7.b[2][0]++;
        cov_1epw84o1x7.s[10]++;
        return;
      } else {
        cov_1epw84o1x7.b[2][1]++;
      }

      cov_1epw84o1x7.s[11]++;
      events.push(fn);
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe(name, fn) {
      cov_1epw84o1x7.f[4]++;
      cov_1epw84o1x7.s[12]++;

      if (!this.$events[name]) {
        cov_1epw84o1x7.b[3][0]++;
        cov_1epw84o1x7.s[13]++;
        return;
      } else {
        cov_1epw84o1x7.b[3][1]++;
      }

      cov_1epw84o1x7.s[14]++;

      if (fn) {
        cov_1epw84o1x7.b[4][0]++;
        cov_1epw84o1x7.s[15]++;
        this.$events[name] = this.$events[name].filter(function (e) {
          cov_1epw84o1x7.f[5]++;
          cov_1epw84o1x7.s[16]++;
          return e !== fn;
        });
      } else {
        cov_1epw84o1x7.b[4][1]++;
        cov_1epw84o1x7.s[17]++;
        delete this.$events[name];
      }
    }
  }]);

  return Notification;
}();

export { Notification as default };